import { FieldHtmlNameUtil } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import AbstractSignupScreen from './AbstractSignupScreen';

export default abstract class AbstractCheckErrorSignupScreen extends AbstractSignupScreen {
  abstract screenName: UnifiedSignupScreenName;

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    return false;
  }

  public async initWatchers(): Promise<void> {
    super.initWatchers();

    document.querySelectorAll('[hekate-data="email"]').forEach((elm) => {
      const email = `${this.getField(FieldHtmlNameUtil.email).val}`;
      if (!email) {
        elm.textContent = 'email';
        return;
      }
      const bits = email.split('@');
      if (bits.length < 2) {
        elm.textContent = 'email';
        return;
      }

      const domain = bits[1];
      const un = bits[0].split('');
      const firstChar = un.shift();
      const lastChar = un.pop();
      const stars = Array(un.length).join('*');
      elm.textContent = `${firstChar}${stars}${lastChar}@${domain}`;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 0;
  }
}
